import { computed } from 'vue'
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
    name: 'Fou-Impersonate-Header',

    setup() {
        const store = useStore();
        const router = useRouter();

        const getLocalStorageFoundryImpersonated = computed(() => {
            return JSON.parse(window.localStorage.getItem('impersonatedFoundry'))
        })

        const stopImpersonation = () => {
            store.dispatch('impersonate/endImpersonation')
                .then((res) => {
                    if (res.success) {
                        store.commit('auth/unSetImpersonateUser')
                        window.localStorage.setItem('permissionsArr', JSON.stringify(['profile']))
                        window.localStorage.removeItem('impersonatedFoundry')
                        window.localStorage.removeItem('sessionFoundryId')
                        window.localStorage.removeItem('sessionFoundryName')
                        window.localStorage.setItem('roles', JSON.stringify(['foundrySupport']))
                        window.localStorage.removeItem('userFoundries')
                        window.localStorage.setItem('isUserAdmin', 'all')
                        window.localStorage.setItem('foundriesTerminated', 'none')
                        store.commit('auth/setContractTerminationMeta', { isUserAdmin: 'none', foundriesTerminated: 'none' })
                        store.commit('auth/setUserRole', ['foundrySupport'])
                        router.push({ name: 'impersonate' })
                   }
                })
        }

        return {
            getLocalStorageFoundryImpersonated,
            stopImpersonation
        }
    }
}